import React from "react";
import { Link } from "react-router-dom";

import Button from 'react-bootstrap/Button';

import Rating from '../Rating/Rating';

import './DealGridItem.css';

function storeName(url) {
  if (! url) {
    return '';
  }
  const re = /\/\/(.*?)([^/.]+\.[^/.]+)\//;
  const matches = url.match(re)
  return matches ? (matches[2] === 'amzn.to' ? 'Amazon' : matches[2]) : url;
}

function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

function DealGridItem({ link: { image, name, _id, url, description, dealText, rating } }) {
  return (
    <div className="m-2">
      <a href={url}>
        {image ? <img alt={name} src={`/image/${image}`} /> : null}
        {dealText ? <div className={image ? 'overlay-deal' : ''}>
                      <div className="site-name">View on {capitalizeFirstLetter(storeName(url))}</div>
                      <div className="deal">{dealText}</div>
                    </div> : null}
      </a>
    </div>
  );
}

export default DealGridItem;
